import React from 'react';
import { Box, CardTypesEnum } from '@common-fe/common-fe';

import { GroupedPlan } from '@/modules/plan/plan.types';

import PlanTypeCard from './PlanTypeCard';

export interface Props {
  activeTemplates?: GroupedPlan[];
  selectedPlanTypes?: CardTypesEnum[];
  isShowedCopayError?: boolean;
  isAbandoned?: boolean;
  isPlanYearEditMode?: boolean;
  onCardSelect: (type: CardTypesEnum) => void;
}

const PlansTypeForm: React.FC<Props> = ({
  activeTemplates,
  selectedPlanTypes,
  isShowedCopayError,
  isAbandoned,
  isPlanYearEditMode,
  onCardSelect,
}) => {  
  return (
    <>
      <Box
        data-testid="plan-type-form"
        round="container1Round"
      >
        {
          activeTemplates?.map((plan, index) => (
            <PlanTypeCard
              key={plan?.categoryEnum}
              type={plan?.categoryEnum}
              isLastItem={index === activeTemplates.length - 1}
              isChecked={selectedPlanTypes?.includes(plan?.categoryEnum)}
              onSelect={onCardSelect}
              isDisabled={isAbandoned || isPlanYearEditMode}
              isSelectedMode
              isShowedCopayError={isShowedCopayError}
            />
          ))
        }
      </Box>
    </>
  );
};

export default PlansTypeForm;
